import { formatSignedPctNumber } from "../../lens-stats/formatters";
import { formatAdditionalInsightsValue } from "../formatters";
import { getInsightsDiffPct } from "../math";
import { type InsightsMetricsMap, type StatsItem } from "../models";

import { computeAdditionalInsightsValues } from "./computeAdditionalInsightsValues";

export const computeAdditionalMetrics = (
    metrics: InsightsMetricsMap<StatsItem>,
    previousMetrics: InsightsMetricsMap<StatsItem>,
): {
    sessionPerUU: string;
    playTimePerSession: string;
    playTimePerUU: string;
    sessionPerUUDiffValue: string;
    playTimePerSessionDiffValue: string;
    playTimePerUUDiffValue: string;
} => {
    const { sessionPerUU, playTimePerSession, playTimePerUU } = computeAdditionalInsightsValues(metrics);
    const previous = computeAdditionalInsightsValues(previousMetrics);

    const sessionPerUUDiffValue = formatSignedPctNumber(getInsightsDiffPct(sessionPerUU, previous.sessionPerUU));
    const playTimePerSessionDiffValue = formatSignedPctNumber(
        getInsightsDiffPct(playTimePerSession, previous.playTimePerSession),
    );
    const playTimePerUUDiffValue = formatSignedPctNumber(getInsightsDiffPct(playTimePerUU, previous.playTimePerUU));

    return {
        sessionPerUU: formatAdditionalInsightsValue(sessionPerUU, "sessions / UU"),
        playTimePerSession: formatAdditionalInsightsValue(playTimePerSession, "sec / session"),
        playTimePerUU: formatAdditionalInsightsValue(playTimePerUU, "sec / session"),
        sessionPerUUDiffValue,
        playTimePerSessionDiffValue,
        playTimePerUUDiffValue,
    };
};
